<script>
    import number from './type/Number.vue';
    import string from './type/String.vue';
    import between from './type/Between.vue';
    import isOneOf from './type/IsOneOf.vue';
    import values from './type/Values.vue';
    import wizard from './type/Wizard.vue';
    import region from './type/Region.vue';
    import arr from './type/Arr.vue';
    import ZenPublicationsTypes from './type/ZenPublicationsTypes.vue';
    import DateRange from './type/DateRange.vue';
    import Enum from './type/Enum.vue';
    import LinksRelTypes from './type/LinksRelTypes.vue';
    import UnixDateRange from './type/UnixDateRange.vue';
    import ip from './type/IP.vue';

    const COMPONENTS_WITHOUT_OPERATORS = ['dateRange', 'unixDateRange'];

    export default {
        data() {
            return {
                filterConfig: null
            }
        },
        props: {
            item:{
                type: Object,
                required: true

            }
        },
        created(){
            this.filterConfig = this.$tm('lang.main.filter_config');
        },
        methods: {

        },
        computed: {
            operators(){
                return this.item.operatorOptions || this.filterConfig[this.item.type] || [];
            },
            component(){
                const ops = this.operators;
                const found = ops.find((e) => e.condition === this.item.operator);
                return found ? found.component : (this.filterConfig[this.item.type]?.[0]?.component || 'string');
            },
            needToShowOperators () {
                return !COMPONENTS_WITHOUT_OPERATORS.includes(this.component)
            }
        },
        components: {
            number,
            string,
            between,
            isOneOf,
            values,
            wizard,
            region,
            ZenPublicationsTypes,
            LinksRelTypes,
            DateRange,
            UnixDateRange,
            Enum,
            arr,
            ip,

        }
    }
</script>
<template>
    <div class="f-row-item">
        <select v-if="needToShowOperators"
                class="operatorselect"
                v-model="item.operator">
            <option v-for="operator in operators" v-bind:value="operator.condition" v-text="operator.label"></option>
        </select>
        <component v-bind:is="component" :item="item"></component>
    </div>
</template>

